// extracted by mini-css-extract-plugin
module.exports = {"container":"privacyPolicy_container__1SX0s","header":"privacyPolicy_header__3LSXS"};